module.exports = __webpack_public_path__ + "static/media/20_000004.1c9aee86.jpg";